"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var MimeTypes;
(function (MimeTypes) {
    MimeTypes["X_MPEG_URL"] = "application/x-mpegURL";
})(MimeTypes || (MimeTypes = {}));
var VideoSources = function (_a) {
    var sources = _a.sources;
    var _b = react_1.useState([]), sourcesList = _b[0], setSourcesList = _b[1];
    react_1.useEffect(function () {
        function getSources() {
            var xMpegURLSource = sources === null || sources === void 0 ? void 0 : sources.find(function (source) { return (source === null || source === void 0 ? void 0 : source.type) === MimeTypes.X_MPEG_URL; });
            if (xMpegURLSource)
                return [xMpegURLSource];
            if (sources === null || sources === void 0 ? void 0 : sources.length)
                return sources;
            return [];
        }
        setSourcesList(getSources());
    }, [sources]);
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: sourcesList === null || sourcesList === void 0 ? void 0 : sourcesList.map(function (source) { return (jsx_runtime_1.jsx("source", { src: source.src, type: source.type }, source.src)); }) }, void 0));
};
exports.default = VideoSources;
